// src/components/Hero/Hero.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import './hero.css';

function Hero() {
  const { t } = useTranslation();

  const handleCallClick = () => {
    window.location.href = `tel:${t('footer.phoneNumber')}`;
  };

  const handleLearnMoreClick = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const headerOffset = 15; // Adjust based on your header height
      const elementPosition = contactSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-content">
          <h1>{t('home.hero.title')}</h1>
          <p>{t('home.hero.subtitle')}</p>
          <div className="hero-buttons">
            <button className="primary-button" onClick={handleCallClick}>
              <i className="fas fa-phone-alt"></i> {t('home.hero.ctaPrimary')}
            </button>
            <button data-type={t('home.hero.ctaSecondary')} className="secondary-button" onClick={handleLearnMoreClick}>
              {t('home.hero.ctaSecondary')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;